import {useState} from "react";

import menus from '../../../../router/menus';
import logo from '../../../../assets/img/logo-branco.png';
import {Link, useNavigate} from "react-router-dom";
import Storage from "../../../../helpers/Storage";
import authApi from "../../../../services/authApi";
export default function AdminNavbar() {
    const [openMenu, setOpenMenu] = useState(false);
    const userData = Storage.getUserData();
    const navigate = useNavigate();
    async function logout(){
        const {data, isError} = await authApi.logout();
        Storage.removeApiToken();
        Storage.removeUserData();
        window.location.href = '/';
    }

    return(
        <nav className="bg-[#003641]">
            <div className="mx-auto  px-2 sm:px-6 lg:px-8">
                <div className="relative flex h-[80px] items-center justify-between">
                    <div className="flex flex-1 items-stretch justify-between">
                        <div className="flex">
                            <img className="w-auto h-[4rem] xs:h-[3rem] hover:cursor-pointer"
                                 onClick={()=>navigate('/')}
                                 src={logo}
                                 alt="Your Company"/>
                        </div>
                        <div className="flex items-center gap-4  xs:hidden md:inline-flex">
                            <ul className="flex space-x-4 font-medium  text-white">
                                <>
                                    <li>
                                        <Link to={'/'}
                                              className={`flex items-center p-3 group hover:opacity-75`}>
                                            <span className="ms-3">Home</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={'/imoveis'}
                                              className={`flex items-center p-3 group hover:opacity-75`}>
                                            <span className="ms-3">Imóveis</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={'/veiculos'}
                                              className={`flex items-center p-3 group hover:opacity-75`}>
                                            <span className="ms-3">Veículos</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to={'/equipamentos'}
                                              className={`flex items-center p-3 group hover:opacity-75`}>
                                            <span className="ms-3">Equipamentos</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <button onClick={() => logout()} className={`flex items-center p-3 group hover:opacity-75`}>
                                            <span className="ms-3">Sair</span>
                                        </button>
                                    </li>
                                    <li>
                                        <div className={'flex items-center p-3'}>
                                            {userData?.usuario.nome.split(' ')[0]}
                                        </div>

                                    </li>
                                </>

                            </ul>
                        </div>
                    </div>
                    <div
                        className="absolute gap-3 inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">

                        {/*Mobile menu button*/}
                        <div className="flex items-center sm:hidden">
                            <button type="button" onClick={() => setOpenMenu(!openMenu)} className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" aria-controls="mobile-menu" aria-expanded="false">
                                <span className="absolute -inset-0.5"></span>
                                <span className="sr-only">Open main menu</span>
                                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"/>
                                </svg>
                                <svg className="hidden h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${openMenu ? '' : 'sm:hidden max-[640px]:hidden'} text-white`} id="mobile-menu">
                <div className="space-y-1 px-2 pb-3 pt-2">
                    {
                        menus.map((menu) => {
                            return(
                                <Link to={menu.path} className={`flex items-center p-3 group hover:text-system-primary`} aria-current="page">
                                    {menu.icon? <menu.icon width={20} height={20} /> : ''}
                                    <span className="ms-3">{menu.title}</span>
                                </Link>
                            )
                        })
                    }
                </div>
            </div>
        </nav>
    )
}